import React from "react";
import Headers from "../../../components/Headers";
import { Input, Row, Col, Button, Table, Modal, Select } from "antd";
import NProgress from "nprogress";
import "./index.scss";
import {
  fetchUserList,
  fetchLevelList,
  fetchtInviteRecord,
} from "../../../api/userInfo";
import fetch from "../../../utils/fetch";
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/userInfo", name: "用户信息" },
];
const { Column } = Table;
const { Option } = Select;
class UserInfo extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      mobilePhone: "",
      level: "",
      sort: 5,
    },
    list: [],
    total: 0,
    userInfo: {},
    levelList: [],
    userInfoVisible: false,
    inviteRecord: [],
    inviteVisible: false,
  };
  componentDidMount() {
    NProgress.start();
    this.getList();
    this.getLevelList();
    NProgress.done();
  }
  getLevelList = () => {
    fetchLevelList().then((res) => {
      if (res.success) {
        this.setState({
          levelList: res.data,
        });
      }
    });
  };
  getList = () => {
    fetchUserList(this.state.listQuery).then((res) => {
      if (res.success) {
        res.data.list.forEach((item) => {
          item.loading = false;
        });
        this.setState({
          list: res.data.list,
          total: res.data.total,
        });
      }
    });
  };
  inputChange = (e) => {
    this.setState({
      listQuery: { ...this.state.listQuery, [e.target.name]: e.target.value },
    });
  };
  renderOption = () => {
    let levelList = [{ level: "", name: "全部等级" }];
    levelList = [...levelList, ...this.state.levelList];
    return levelList.map((item) => {
      return (
        <Option key={item.level} value={item.level}>
          {item.name}
        </Option>
      );
    });
  };
  handleSearch = () => {
    this.setState(
      {
        listQuery: { ...this.state.listQuery, pageNum: 1 },
      },
      () => {
        this.getList();
      }
    );
  };
  handleExport = () => {
    let str = "?";
    const { listQuery } = this.state;
    Object.keys(listQuery).forEach((item) => {
      str += item + "=" + listQuery[item] + "&";
    });
    str +=
      "accessToken=" +
      JSON.parse(sessionStorage.getItem("loginInfo")).accessToken;
    window.open(process.env.REACT_APP_API_PREFIX + "user/list/export" + str);
  };
  viewDetails = (record, state, index) => {
    //state 1查看个人资料 2查看详情 3查看邀请记录
    switch (state) {
      case 1:
        this.setState({
          userInfo: record,
          userInfoVisible: true,
        });
        break;
      case 2:
        this.props.history.push("/page/ssry/integraDetails/" + record.numId);
        break;
      case 3:
        let list = this.state.list;
        list[index].loading = true;
        this.setState({
          list,
        });
        fetchtInviteRecord(record.numId).then((res) => {
          if (res.success) {
            list[index].loading = false;

            this.setState({
              inviteRecord: res.data,
              inviteVisible: true,
              list,
            });
          }
        });
        break;
    }
  };
  userInfoCancel = () => {
    this.setState({
      userInfoVisible: false,
    });
  };
  renderGender = (gender) => {
    switch (gender) {
      case 1:
        return "男";
        break;
      case 2:
        return "女";
        break;
      default:
        return "未知";
        break;
    }
  };
  levelChange = (e) => {
    this.setState({
      listQuery: { ...this.state.listQuery, level: e },
    });
  };
  tableChange = (pagination, filters, sorter) => {
    let sort = 5;
    if (sorter.field) {
      if (sorter.field == "integral") {
        sort = sorter.order == "ascend" ? 1 : sorter.order == "descend" ? 2 : 5;
      } else if (sorter.field == "invitationNum") {
        sort = sorter.order == "ascend" ? 4 : sorter.order == "descend" ? 3 : 5;
      } else if (sorter.field == "createTime") {
        sort = sorter.order == "ascend" ? 6 : sorter.order == "descend" ? 5 : 5;
      }
    }
    this.setState(
      {
        listQuery: {
          ...this.state.listQuery,
          pageNum:
            this.state.listQuery.pageSize == pagination.pageSize
              ? pagination.current
              : 1,
          pageSize: pagination.pageSize,
          sort,
        },
      },
      () => {
        this.getList();
      }
    );
  };
  inviteCancel = () => {
    this.setState({
      inviteVisible: false,
    });
  };
  render() {
    const {
      listQuery,
      list,
      total,
      userInfoVisible,
      userInfo,
      inviteVisible,
      inviteRecord,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="userInfo_container">
          <Row className="searchTop">
            <Col span={20}>
              <Input
                className="marginR"
                style={{ width: 170 }}
                name="mobilePhone"
                onChange={this.inputChange}
                value={listQuery.mobilePhone}
                placeholder="手机号码"
                allowClear
              />
              <Select
                className="marginR"
                style={{ width: 150 }}
                value={listQuery.level}
                onChange={this.levelChange}
              >
                {this.renderOption()}
              </Select>
              <Button onClick={this.handleSearch} type="primary">
                搜索
              </Button>
            </Col>
            <Col span={4}>
              <Button onClick={this.handleExport} className="fr" type="primary">
                导出
              </Button>
            </Col>
          </Row>
          <div className="content">
            <Table
              rowKey="numId"
              dataSource={list}
              onChange={this.tableChange}
              // locale={{ emptyText: "暂无商户" }}
              pagination={{
                showTotal: () => `共${total}条`,
                total: total,
                current: listQuery.pageNum,
                pageSize: listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                // onChange: (page, pageSize) => {
                //   this.setState(
                //     {
                //       listQuery: { ...listQuery, pageNum: page },
                //     },
                //     () => this.getList()
                //   );
                // },
                // onShowSizeChange: (current, pageSize) => {
                //   this.setState(
                //     {
                //       listQuery: { ...listQuery, pageSize, pageNum: 1 },
                //     },
                //     () => this.getList()
                //   );
                // },
              }}
            >
              <Column
                sorter={true}
                title="注册时间"
                dataIndex="createTime"
                key="createTime"
              />
              <Column title="用户昵称" dataIndex="nickName" key="nickName" />
              <Column
                title="手机号码"
                dataIndex="mobilePhone"
                key="mobilePhone"
              />
              <Column
                title="会员等级"
                dataIndex="memberName"
                key="memberName"
              />
              <Column
                sorter={true}
                title="当前积分"
                dataIndex="integral"
                key="integral"
              />
              <Column
                title="个人资料"
                render={(record) => {
                  return (
                    <React.Fragment>
                      <a onClick={() => this.viewDetails(record, 1)}>
                        查看详情
                      </a>
                    </React.Fragment>
                  );
                }}
              />
              <Column
                title="积分明细"
                render={(record) => {
                  return (
                    <React.Fragment>
                      <a onClick={() => this.viewDetails(record, 2)}>
                        查看明细
                      </a>
                    </React.Fragment>
                  );
                }}
              />
              <Column
                sorter={true}
                title="邀请人数"
                dataIndex="invitationNum"
                key="invitationNum"
              />
              <Column
                title="邀请记录"
                render={(record, value, index) => {
                  return (
                    <React.Fragment>
                      <Button
                        loading={list[index].loading}
                        type="link"
                        className="viewDetail"
                        onClick={() => this.viewDetails(record, 3, index)}
                      >
                        查看记录
                      </Button>
                    </React.Fragment>
                  );
                }}
              />
            </Table>
          </div>
        </div>
        <Modal
          title="邀请记录"
          width={700}
          visible={inviteVisible}
          onCancel={this.inviteCancel}
          footer={null}
        >
          <div
            style={{ maxHeight: 500, overflow: "auto" }}
            className="modal_content"
          >
            <div>
              <span style={{ color: "#D0021B" }}>*</span>
              被邀请人购买试试如意会员视为邀请成功
            </div>
            <Table
              style={{ marginTop: 14 }}
              dataSource={inviteRecord}
              rowKey={() => Math.random()}
              pagination={false}
            >
              <Column title="ID" render={(a, b, index) => index + 1} />
              <Column
                title="邀请时间"
                dataIndex="createTime"
                key="createTime"
              />
              <Column title="用户昵称" dataIndex="nickName" key="nickName" />
              <Column
                title="手机号码"
                dataIndex="mobilePhone"
                key="mobilePhone"
              />
            </Table>
          </div>
        </Modal>
        <Modal
          className="userInfoModal"
          title="查看个人资料"
          width={600}
          visible={userInfoVisible}
          onCancel={this.userInfoCancel}
          footer={null}
        >
          <div className="modal_content">
            <img className="avatar" src={userInfo.headPortrait}></img>
            <div className="label">
              姓名：
              {userInfo.name ? (
                userInfo.name
              ) : (
                <span className="notWrite">暂未填写</span>
              )}
            </div>
            <div className="label">
              性别：
              {userInfo.gender ? (
                this.renderGender(userInfo.gender)
              ) : (
                <span className="notWrite">暂未填写</span>
              )}
            </div>
            <div className="label">
              生日：
              {userInfo.birthday ? (
                userInfo.birthday
              ) : (
                <span className="notWrite">暂未填写</span>
              )}
            </div>
            <div className="label">
              职业：
              {userInfo.position ? (
                userInfo.position
              ) : (
                <span className="notWrite">暂未填写</span>
              )}
            </div>
            <div className="label">
              常住地区：
              {(userInfo.address + "").trim() ? (
                (userInfo.address + "").trim()
              ) : (
                <span className="notWrite">暂未填写</span>
              )}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default UserInfo;
